import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const TextMessageIcon = memo(({ className, color = colors.grey120 }: SvgIconProps) => {
  return (
    <SvgIcon
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ color: 'transparent' }}
    >
      <path
        d="M12.722 16.51L12.711 20.989C12.4864 22.301 11.349 23.2601 10.018 23.26H3.483C1.974 23.26 0.750552 22.037 0.75 20.528V4.99301C0.750552 3.48384 1.97383 2.26056 3.483 2.26001H9.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 19.885C6.54289 19.885 6.375 20.0529 6.375 20.26C6.375 20.4671 6.54289 20.635 6.75 20.635C6.95711 20.635 7.125 20.4671 7.125 20.26C7.125 20.0529 6.95711 19.885 6.75 19.885V19.885"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 14.26V14.26C3.75 12.6032 5.09315 11.26 6.75 11.26V11.26C8.40685 11.26 9.75 12.6032 9.75 14.26V14.26"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 11.26C7.99264 11.26 9 10.2527 9 9.01001C9 7.76737 7.99264 6.76001 6.75 6.76001C5.50736 6.76001 4.5 7.76737 4.5 9.01001C4.5 10.2527 5.50736 11.26 6.75 11.26Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 0.760065C15.9396 0.750594 14.066 1.95261 13.2157 3.82938C12.3654 5.70615 12.6973 7.90734 14.063 9.45007L13.406 13.2291L16.829 11.1191C18.7941 11.5702 20.8439 10.8551 22.1021 9.27961C23.3602 7.70407 23.6041 5.54687 22.7294 3.73023C21.8547 1.91358 20.0162 0.759 18 0.760065Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
});
